import { withLoyaltyStore } from "../../utils/withLoyaltyStore";

import { ReferralHistory as ReferralHistoryBase } from "./ReferralHistory";

export type * from "./ReferralHistory";
export const ReferralHistory = withLoyaltyStore(ReferralHistoryBase, "ReferralHistory");
